module.exports = __webpack_public_path__ + "img/head_four.afb3118d.png";